import React from "react";
import { PATH } from "../PATH/Path";


const Profile = React.lazy(() => import('../../components/profile/Profile'))
const Dashboard = React.lazy(() => import('../../components/dashboard/Dashboard'))
const Orders = React.lazy(() => import('../../components/orders/Orders'))
const CreateOrder = React.lazy(() => import('../../components/orders/CreateOrder'))
const EditOrder = React.lazy(() => import('../../components/orders/EditOrder'))
const Kits = React.lazy(() => import('../../components/kits/Kits'))
const Batches = React.lazy(() => import('../../components/batches/Batches'))
const CreateBatch = React.lazy(() => import('../../components/batches/CreateBatch'))
const Bioinformatics = React.lazy(() => import('../../components/dataAnalysis/bioinformatics/Bioinformatics'))
const MLAnalysis = React.lazy(() => import('../../components/dataAnalysis/mlAnalysis/MLAnalysis'))
const ReportGeneration = React.lazy(() => import('../../components/dataAnalysis/reportGeneration/ReportGeneration'))
const SamplesOfReportGeneration = React.lazy(() => import('../../components/dataAnalysis/reportGeneration/SampleOfReportGeneration'))
const QualityControl = React.lazy(() => import('../../components/dataAnalysis/qualityControl/QualityControl'))
const SamplesOfQualityControl = React.lazy(() => import('../../components/dataAnalysis/qualityControl/SamplesOfQualityControl'))
const Products = React.lazy(() => import('../../components/products/Products'))
const AddProducts = React.lazy(() => import('../../components/products/AddProducts'))
const EditProducts = React.lazy(() => import('../../components/products/EditProducts'))
const Clients = React.lazy(() => import('../../components/clients/Clients'))
const AddClient = React.lazy(() => import('../../components/clients/AddClient'))
const EditClient = React.lazy(() => import('../../components/clients/EditClient'))
const Scripts = React.lazy(() => import('../../components/management/scripts/Scripts'))
const AddScript = React.lazy(() => import('../../components/management/scripts/AddScript'))
const HistoryOfScripts = React.lazy(() => import('../../components/management/scripts/HistoryOfScripts'))
const ManagementMenu = React.lazy(() => import('../../components/management/Management'))
const UsersAndPermissions = React.lazy(() => import('../../components/management/users/Users'))
const AddUser = React.lazy(() => import('../../components/management/users/AddUser'))
const EditUser = React.lazy(() => import('../../components/management/users/EditUser'))
const RolesAndPermissions = React.lazy(() => import('../../components/management/rolesAndpermissions/RolesAndPermissions'))
const UserPermission = React.lazy(() => import('../../components/management/rolesAndpermissions/UserPermission'))
const ListOfBarcodes = React.lazy(() => import('../../components/batches/ListOfBarcodes'))
const SamplesOfBioinformatics = React.lazy(() => import('../../components/dataAnalysis/bioinformatics/SamplesOfBioinformatics'))
const CreateSample = React.lazy(() => import('../../components/batches/CreateSample'))
const UpdateBatch = React.lazy(() => import('../../components/batches/UpdateBatch'))
const SamplesOfMlanalysis = React.lazy(() => import('../../components/dataAnalysis/mlAnalysis/SamplesOfMlanalysis'))
const Metadata = React.lazy(() => import('../../components/metadata/Metadata'))
const RAnalysis = React.lazy(() => import('../../components/dataAnalysis/rAnalysis/RAnalysis'))
const SampleOfRAnalysis = React.lazy(() => import('../../components/dataAnalysis/rAnalysis/SampleOfRAnalysis'))
const ReportTemplate = React.lazy(() => import('../../components/reportTemplate/ReportTemplate'))
const CreateReportTemplate = React.lazy(() => import('../../components/reportTemplate/CreateReportTemplate'))
const UpdateReportTemplate = React.lazy(() => import('../../components/reportTemplate/UpdateReportTemplate'))
const HistoryOfReportTemplate = React.lazy(() => import('../../components/reportTemplate/HistoryOfReportTemplate'))
const AuditLog = React.lazy(() => import('../../components/auditLog/AuditLog'))
const DataAnalysis = React.lazy(() => import('../../components/dataAnalysis/dataAnalysis'))
const DataCuration = React.lazy(() => import('../../components/datacuration/DataCuration'))
const UploadDataCuration = React.lazy(() => import('../../components/datacuration/UploadDataCuration'))
const HistoryOfDataCuration = React.lazy(() => import('../../components/datacuration/HistoryOfDataCuration'))
const Freezer = React.lazy(() => import('../../components/inventory/Freezer'))
const LabConsumables = React.lazy(() => import('../../components/inventory/LabConsumables'))
const GutcheckSupplies = React.lazy(() => import('../../components/inventory/GutcheckSupplies'))
const HistoryOfGutcheckSupplies = React.lazy(() => import('../../components/inventory/HistoryOfGutcheckSupplies'))
const HistoryOfLabConsumables = React.lazy(() => import('../../components/inventory/HistoryOfLabConsumables'))
const DeidentifiedData = React.lazy(() => import('../../components/batches/DeidentifiedData'))
const HistoryOfSample = React.lazy(() => import('../../components/batches/HistoryOfSample'))


export const Auth_Routes = [

    {
        ROUTE_CODE: "DASHBOARD",
        ROUTE_PATH: PATH.DASHBOARD,
        ROUTE_COMPONENT: <Dashboard />
    },

    {
        ROUTE_CODE: "ORDERS",
        ROUTE_PATH: PATH.ORDERS,
        ROUTE_COMPONENT: <Orders />
    },
    {
        ROUTE_CODE: "CREATE_ORDER",
        ROUTE_PATH: PATH.CREATE_ORDER,
        ROUTE_COMPONENT: <CreateOrder />
    }, {
        ROUTE_CODE: "UPDATE_ORDER",
        ROUTE_PATH: PATH.UPDATE_ORDER,
        ROUTE_COMPONENT: <EditOrder />
    },

    {
        ROUTE_CODE: "KITS",
        ROUTE_PATH: PATH.KITS,
        ROUTE_COMPONENT: <Kits />
    },

    {
        ROUTE_CODE: "BATCHES",
        ROUTE_PATH: PATH.BATCHES,
        ROUTE_COMPONENT: <Batches />
    },

    {
        ROUTE_CODE: "CREATE_BATCH",
        ROUTE_PATH: PATH.CREATE_BATCH,
        ROUTE_COMPONENT: < CreateBatch />
    },

    {
        ROUTE_CODE: "UPDATE_BATCH",
        ROUTE_PATH: PATH.UPDATE_BATCH,
        ROUTE_COMPONENT: < UpdateBatch />
    },

    {
        ROUTE_CODE: "LIST_OF_BARCODES",
        ROUTE_PATH: PATH.LIST_OF_BARCODES,
        ROUTE_COMPONENT: < ListOfBarcodes />
    },

    {
        ROUTE_CODE: "CREATE_SAMPLE",
        ROUTE_PATH: PATH.CREATE_SAMPLE,
        ROUTE_COMPONENT: < CreateSample />
    },
    {
        ROUTE_CODE: "SAMPLE_HISTORY",
        ROUTE_PATH: PATH.SAMPLE_HISTORY,
        ROUTE_COMPONENT: <HistoryOfSample />
    },
    {
        ROUTE_CODE: "DATA_ANALYSIS",
        ROUTE_PATH: PATH.DATA_ANALYSIS,
        ROUTE_COMPONENT: < DataAnalysis />
    },

    {
        ROUTE_CODE: "BIOINFORMATICS",
        ROUTE_PATH: PATH.BIOINFORMATICS,
        ROUTE_COMPONENT: <Bioinformatics />
    },
    {
        ROUTE_CODE: "SAMPLES_BIOINFORMATICS",
        ROUTE_PATH: PATH.SAMPLES_BIOINFORMATICS,
        ROUTE_COMPONENT: <SamplesOfBioinformatics />
    },
    {
        ROUTE_CODE: "ML_ANALYSIS",
        ROUTE_PATH: PATH.ML_ANALYSIS,
        ROUTE_COMPONENT: <MLAnalysis />
    },
    {
        ROUTE_CODE: "SAMPLES_ML_ANALYSIS",
        ROUTE_PATH: PATH.SAMPLES_ML_ANALYSIS,
        ROUTE_COMPONENT: <SamplesOfMlanalysis />
    },
    {
        ROUTE_CODE: "R_ANALYSIS",
        ROUTE_PATH: PATH.R_ANALYSIS,
        ROUTE_COMPONENT: <RAnalysis />
    },
    {
        ROUTE_CODE: "SAMPLES_R_ANALYSIS",
        ROUTE_PATH: PATH.SAMPLES_R_ANALYSIS,
        ROUTE_COMPONENT: <SampleOfRAnalysis />
    },
    {
        ROUTE_CODE: "REPORT_GENERATION",
        ROUTE_PATH: PATH.REPORT_GENERATION,
        ROUTE_COMPONENT: <ReportGeneration />
    },
    {
        ROUTE_CODE: "SAMPLES_REPORT_GENERATION",
        ROUTE_PATH: PATH.SAMPLES_REPORT_GENERATION,
        ROUTE_COMPONENT: <SamplesOfReportGeneration />
    },
    {
        ROUTE_CODE: "QUALITY_CONTROL",
        ROUTE_PATH: PATH.QUALITY_CONTROL,
        ROUTE_COMPONENT: <QualityControl />
    },
    {
        ROUTE_CODE: "SAMPLES_QUALITY_CONTROL",
        ROUTE_PATH: PATH.SAMPLES_QUALITY_CONTROL,
        ROUTE_COMPONENT: <SamplesOfQualityControl />
    },
    {
        ROUTE_CODE: "METADATA",
        ROUTE_PATH: PATH.METADATA,
        ROUTE_COMPONENT: <Metadata />
    },

    {
        ROUTE_CODE: "PRODUCTS",
        ROUTE_PATH: PATH.PRODUCTS,
        ROUTE_COMPONENT: <Products />
    },
    {
        ROUTE_CODE: "CREATE_PRODUCTS",
        ROUTE_PATH: PATH.CREATE_PRODUCTS,
        ROUTE_COMPONENT: <AddProducts />
    },
    {
        ROUTE_CODE: "UPDATE_PRODUCTS",
        ROUTE_PATH: PATH.UPDATE_PRODUCTS,
        ROUTE_COMPONENT: <EditProducts />
    },

    {
        ROUTE_CODE: "CLIENTS",
        ROUTE_PATH: PATH.CLIENTS,
        ROUTE_COMPONENT: <Clients />
    },
    {
        ROUTE_CODE: "CREATE_CLIENT",
        ROUTE_PATH: PATH.CREATE_CLIENT,
        ROUTE_COMPONENT: <AddClient />
    },
    {
        ROUTE_CODE: "UPDATE_CLIENT",
        ROUTE_PATH: PATH.UPDATE_CLIENT,
        ROUTE_COMPONENT: <EditClient />
    },

    {
        ROUTE_CODE: "SCRIPTS",
        ROUTE_PATH: PATH.SCRIPTS,
        ROUTE_COMPONENT: <Scripts />
    },
    {
        ROUTE_CODE: "UPLOAD_SCRIPT",
        ROUTE_PATH: PATH.UPLOAD_SCRIPT,
        ROUTE_COMPONENT: <AddScript />
    },
    {
        ROUTE_CODE: "SCRIPT_HISTORY",
        ROUTE_PATH: PATH.SCRIPT_HISTORY,
        ROUTE_COMPONENT: <HistoryOfScripts />
    },

    {
        ROUTE_CODE: "MANAGEMENT",
        ROUTE_PATH: PATH.MANAGEMENT,
        ROUTE_COMPONENT: <ManagementMenu />
    },

    {
        ROUTE_CODE: "MANAGEMENT_USERS",
        ROUTE_PATH: PATH.USERS,
        ROUTE_COMPONENT: <UsersAndPermissions />
    },
    {
        ROUTE_CODE: "MANAGEMENT_CREATE_USER",
        ROUTE_PATH: PATH.CREATE_USER,
        ROUTE_COMPONENT: <AddUser />
    },
    {
        ROUTE_CODE: "MANAGEMENT_UPDATE_USER",
        ROUTE_PATH: PATH.UPDATE_USER,
        ROUTE_COMPONENT: <EditUser />
    },

    {
        ROUTE_CODE: "MANAGEMENT_ROLES",
        ROUTE_PATH: PATH.ROLES,
        ROUTE_COMPONENT: <RolesAndPermissions />
    },
    {
        ROUTE_CODE: "MANAGEMENT_UPDATE_ROLE_PERMISSION",
        ROUTE_PATH: PATH.UPDATE_ROLE_PERMISSION,
        ROUTE_COMPONENT: <UserPermission />
    },

    {
        ROUTE_CODE: "MY_PROFILE",
        ROUTE_PATH: PATH.MY_PROFILE,
        ROUTE_COMPONENT: <Profile />
    },

    {
        ROUTE_CODE: "REPORT_TEMPLATE",
        ROUTE_PATH: PATH.REPORT_TEMPLATE,
        ROUTE_COMPONENT: <ReportTemplate />
    },
    {
        ROUTE_CODE: "CREATE_REPORT_TEMPLATE",
        ROUTE_PATH: PATH.CREATE_REPORT_TEMPLATE,
        ROUTE_COMPONENT: <CreateReportTemplate />
    },
    {
        ROUTE_CODE: "UPDATE_REPORT_TEMPLATE",
        ROUTE_PATH: PATH.UPDATE_REPORT_TEMPLATE,
        ROUTE_COMPONENT: <UpdateReportTemplate />
    },
    {
        ROUTE_CODE: "REPORT_TEMPLATE_HISTORY",
        ROUTE_PATH: PATH.REPORT_TEMPLATE_HISTORY,
        ROUTE_COMPONENT: <HistoryOfReportTemplate />
    },
    {
        ROUTE_CODE: "AUDIT_LOG",
        ROUTE_PATH: PATH.AUDIT_LOG,
        ROUTE_COMPONENT: <AuditLog />
    },

    {
        ROUTE_CODE: "DATA_CURATION",
        ROUTE_PATH: PATH.DATA_CURATION,
        ROUTE_COMPONENT: <DataCuration />
    },

    {
        ROUTE_CODE: "UPLOAD_DATA_CURATION",
        ROUTE_PATH: PATH.UPLOAD_DATA_CURATION,
        ROUTE_COMPONENT: <UploadDataCuration />
    },
    {
        ROUTE_CODE: "DATA_CURATION_HISTORY",
        ROUTE_PATH: PATH.DATA_CURATION_HISTORY,
        ROUTE_COMPONENT: <HistoryOfDataCuration />
    },
    {
        ROUTE_CODE: "FREEZER",
        ROUTE_PATH: PATH.FREEZER,
        ROUTE_COMPONENT: <Freezer />
    },
    {
        ROUTE_CODE: "LAB_CONSUMABLES",
        ROUTE_PATH: PATH.LAB_CONSUMABLES,
        ROUTE_COMPONENT: <LabConsumables />
    },
    {
        ROUTE_CODE: "GUTCHECK_SUPPLIES",
        ROUTE_PATH: PATH.GUTCHECK_SUPPLIES,
        ROUTE_COMPONENT: <GutcheckSupplies />
    },
    {
        ROUTE_CODE: "HISTORY_OF_GUTCHECK_SUPPLIES",
        ROUTE_PATH: PATH.HISTORY_OF_GUTCHECK_SUPPLIES,
        ROUTE_COMPONENT: <HistoryOfGutcheckSupplies />
    },
    {
        ROUTE_CODE: "HISTORY_OF_LAB_CONSUMABLES",
        ROUTE_PATH: PATH.HISTORY_OF_LAB_CONSUMABLES,
        ROUTE_COMPONENT: <HistoryOfLabConsumables />
    },
    {
        ROUTE_CODE: "DEIDENTIFIED_DATA",
        ROUTE_PATH: PATH.DEIDENTIFIED_DATA,
        ROUTE_COMPONENT: <DeidentifiedData />
    },


]